// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"RP-z","categoryName":"SP-z","categoryNameSearchHeader":"TP-z","categoryContent":"UP-z","bottomAligned":"VP-z","image":"WP-z","imageNoBackground":"XP-z"};